module.exports = __webpack_public_path__ + "static/media/ic_covid_b_1_myway.4bd4126c.svg";